import { render, staticRenderFns } from "./RptBooking.vue?vue&type=template&id=0b866297&"
import script from "./RptBooking.vue?vue&type=script&lang=js&"
export * from "./RptBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports